import Vue from 'vue'
import VueRouter from 'vue-router'
import Building from '../components/Building.vue'
import Login from '../components/Login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    name: 'Building',
    component: Building,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/register',
    name: 'Register',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/Register.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/budynek/dodaj',
    name: 'BuildingAdd',
    props:true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/BuildingDetails.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/budynek/edytuj/:id',
    name: 'BuildingEdit',
    props:true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/BuildingDetails.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/budynek/edytuj/obrazki/:id',
    name: 'BuildingImagesEdit',
    props:true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/BuildingImages.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/osoby',
    name: 'People',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/People.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/osoba/dodaj',
    name: 'PeopleAdd',
    props:true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/PeopleDetails.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/osoba/edytuj/:id',
    name: 'PeopleEdit',
    props:true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/PeopleDetails.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/osoba/edytuj/obrazki/:id',
    name: 'PeopleImagesEdit',
    props:true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/PeopleImages.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/bibliografia',
    name: 'Bibliography',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/Bibliography.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/bibliografia/dodaj',
    name: 'BibliographyAdd',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/BibliographyDetails.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/bibliografia/edytuj/:id',
    name: 'BibliographyEdit',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/BibliographyDetails.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/o-projekcie',
    name: 'AboutProject',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/AboutProject.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/edukacja',
    name: 'Education',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/Education.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/edukacja/dodaj',
    name: 'EducationAdd',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/EducationDetails.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/edukacja/edytuj/:id',
    name: 'EducationEdit',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/EducationDetails.vue'),
    meta: {
      requiresAuth: true
    }
  },


  {
    path: '*',
    component: Building
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  // eslint-disable-next-line no-unused-vars
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
// eslint-disable-next-line no-unused-vars
router.beforeEach((to, from, next) => {
  //check to see if route requires auth

  if (to.matched.some(rec => rec.meta.requiresAuth)) {
    //user signed in  proceed to route, local storage?
    let signedIn = localStorage.isSignedIn == 'true'
    if (signedIn) {
      next()
    }
    else {
      //no user signe in redirect to login
      next({ name: 'Login' })
    }
  }
  else {
    next()
  }
})

export default router
